module.exports = __webpack_public_path__ + "img/Nordstrom_case_study_4.ca557443.png";